import React, { Component } from 'react';
import ReactModal from 'react-modal';
import '../assets/teachers.css';
import logo from '../assets/images/logo_avenuepm.png';
import REST from "./REST";
import {selectSchool, userLogout} from "../TeachersComponent/actions";
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import DropDownNotifications from "./DropDownNotifications";
import ReportBugForm from "../ModalFormComponents/ReportBugForm";
import Select from 'react-select';

import logo_maze from '../assets/images/logo_maze.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsignsay.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import Creatable from "../RequestAccountComponent/RequestAccount";
import TRACKING from "./DataTrackingPoints";
import DialogBox from "./DialogBox";

let appIcon = "";

let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;
let KidspeakInstruction = null;

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '45%'
    }
};

const getValue = (opts, val) => opts.find(o => o.value === val);

class ResourcesLinkComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openSurvey: false,
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    handleSurveyBack(){

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                openSurvey: true,
                analytics: {
                    type: TRACKING.RESOURCES_DOWNLOAD,
                    metadata: {resourceId: this.props.value},
                }
            },
            ()=> this.handleAnalytics());
    }

    render(){
        let sameTab = this.props.sameTab;
        let target;
        if (sameTab){
            target="";
        }else{
            target="_blank";
        }
        return (
            <li>
                <DialogBox surveyModal role={'teacher'} app={'ResourceLink'} userId={this.props.teacherId} active={this.state.openSurvey} surveyBack={this.handleSurveyBack}/>

                {this.props.download==="No"?<a onClick={this.handleClick}
                                               href={this.props.url} target={target} >{this.props.title}</a>:
                <a onClick={this.handleClick}
                   href={this.props.url} target={target} download>{this.props.title}</a>}</li>
        )
    }
}

class VideoTutorialComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                analytics: {
                    type: TRACKING.VIDEO_PLAY,
                    metadata: {videoId: this.props.id},
                }
            },
            ()=> this.handleAnalytics());
        this.props.handleOpenVideo(this.props.id, this.props.title, this.props.url);
    }

    render(){
        return (
            <li><a onClick={this.handleClick}>{this.props.title}</a></li>
        )
    }
}

const Header = class HeaderComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
            getStarted: false,
            schoolOptions: [],
            schoolValue: '',
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        };
        this.handleOpenVideo=this.handleOpenVideo.bind(this);
        this.handleCloseVideo=this.handleCloseVideo.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleTeachers = this.handleTeachers.bind(this);
        this.handleSchools = this.handleSchools.bind(this);
        this.handleContent = this.handleContent.bind(this);
        this.handleGetStarted = this.handleGetStarted.bind(this);
        this.closeGetStarted = this.closeGetStarted.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    async componentDidMount() {
        if (this.props.schoolAdmin) {
            await REST.listAdminSchools(this.props.schoolAdmin.id).then(async(response) => {
                if (response.success) {
                    let data = response.body;
                    let schools = [];
                    for (let school of data) {
                        schools.push({value: school.id, label: school.name});
                    }
                    await this.setState({schoolOptions: schools});
                    await this.props.schoolLoaded(schools);
                    if(this.props.lastSchool){
                        await this.setState({schoolValue:this.props.lastSchool});
                    }
                } else {
                    console.log('Error', response.msg);
                }
            }, (error) => {
                console.log('Error', error.msg);
            });
        }
    }

    handleSurveyBack(){

    }

    handleOpenVideo(id, title, url){
        this.setState({
            showVideo:true,
            videoURL:url,
            videoId: id,
            videoTitle:title
        })
    }

    handleCloseVideo(){
        this.setState({
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        })
    }

    handleSchoolChange = async(newValue) => {
        await this.setState({ schoolValue: newValue.value});
        await this.props.selectSchool(newValue.value);
        console.log('school select:' + this.props.lastSchool);
        this.props.changeSchool(newValue.value);
    };

    handleTeachers(event) {
        this.props.history.push("/admin");
    }

    handleContent(event) {
        this.props.history.push("/content");
    }

    handleSchools(event) {
        this.props.history.push("/school-management");
    }

    handleGetStarted(event){
        this.setState({getStarted: true});
    }

    closeGetStarted(event){
        this.setState({getStarted: false});
    }

    handleLogout = async () => {
        await REST.logout().then(async (response) => {
            if (response.success) {
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                await this.props.persistor.purge();
                await this.props.userLogout();
                this.props.history.push("/");
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    };

    render() {
        let PNModel;
        if(this.props.appName === 'Picture Naming'){
            appIcon = logo_picturenaming;
            if(this.props.PNModel === "computer"){
                PNModel = "(Computer Tasks)";
            }else if (this.props.PNModel === "manual"){
                PNModel = "(Picture Cards)";
            }else{
                PNModel = "(1-1 Computer Tasks)";
            }
        }
        if(this.props.appName === 'CopyRight'){
            appIcon = logo_copyright;
        }
        if(this.props.appName === 'Word Sign/Say'){
            appIcon = logo_wordsignsay;
        }
        if(this.props.appName === 'Slash'){
            appIcon = logo_slashtest;
        }
        if(this.props.appName === 'KidSpeak'){
            appIcon = logo_kidspeak;
        }
        if(this.props.appName === 'Maze'){
            appIcon = logo_maze;
        }
        if(this.props.appName === 'KidSign'){
            appIcon = logo_kidsign;
        }
        if(this.props.appName === 'WordMark'){
            appIcon = logo_wordmark;
        }

        return (
            <nav id="header" className="navbar">
                <div id="header-container" className="container navbar-container">
                    <div className="navbar-header fl">
                        <a id="brand" className="navbar-brand" href="/">
                            <img src={logo} alt="AvenuePM Home" border="0" />
                        </a>
                    </div>
                    {
                        this.props.admin||this.props.contentManagement||this.props.schoolManagement ?
                            <div className={"navbar col-md-6"}>
                                <div id="navbar" className="navbar fr" onClick={this.handleContent}>
                                    <a className={this.props.contentManagement?"handBtn active":"handBtn "}>
                                        <span>Content</span>
                                    </a>
                                </div>
                                {this.props.userId == 100 ? <div>
                                    <div id="navbar" className="navbar fr" onClick={this.handleTeachers}>
                                        <a className={this.props.admin?"handBtn active":"handBtn "}>
                                            <span>Teachers</span>
                                        </a>
                                    </div>
                                    <div id="navbar" className="navbar fr" onClick={this.handleSchools}>
                                        <a className={this.props.schoolManagement?"handBtn active":"handBtn "}>
                                            <span>Schools</span>
                                        </a>
                                    </div>
                                    </div>:null}
                            </div>
                            :
                            null
                    }
                    {
                        this.props.schoolAdmin?
                            <div className={"navbar col-md-6"}>
                                <div className={"row"}>
                                    <div className={"col-md-5 "} >
                                        <h1 style={{marginLeft:50}}>
                                            School:
                                        </h1>
                                    </div>
                                    <div className={"col-md-7"} style={{marginLeft:-80}}>
                                        <Select
                                            onChange={this.handleSchoolChange}
                                            options={this.state.schoolOptions}
                                            placeholder = {"Select a school..."}
                                            value={getValue(this.state.schoolOptions, this.state.schoolValue)}
                                        />
                                     </div>
                                </div>
                        </div>:null

                    }
                    {
                        this.props.dataCharts ?
                            <div className={"navbar col-md-6"}>
                                {this.props.imageSrc ?
                                    <h3 style={{
                                        fontSize: 25,
                                        position: 'relative',
                                        fontWeight: 'normal',
                                        top:-10
                                    }}><img src={appIcon}  alt={this.props.appName} style={{position:'relative',top:-4,width:45,borderRadius:'25%',border:'1px dashed #000'}}/> {this.props.sName.user.firstname} {this.props.sName.user.lastname} {PNModel}
                                    </h3>
                                    :
                                    <h3 style={{
                                        fontSize: 25,
                                        position: 'relative',
                                        top: 5,
                                        fontWeight: 'normal'
                                    }}>{this.props.appName} : {this.props.sName.user.firstname} {this.props.sName.user.lastname} {PNModel}</h3>
                                }
                            </div>
                            :
                            null
                    }
                    {
                        this.props.gradingApps ?
                            <div className={"navbar col-md-6"}>
                                {this.props.imageSrc ?
                                    <h3 style={{
                                        fontSize: 25,
                                        position: 'relative',
                                        fontWeight: 'normal'
                                    }}><img src={this.props.imageSrc}  style={{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}/> {this.props.sName.user.firstname} {this.props.sName.user.lastname}
                                    </h3>
                                    :
                                    <h3 style={{
                                        fontSize: 25,
                                        position: 'relative',
                                        top: 5,
                                        fontWeight: 'normal'
                                    }}>{this.props.appName} : {this.props.sName.user.firstname} {this.props.sName.user.lastname} {this.PNModel}</h3>
                                }
                            </div>
                            :
                            null
                    }
                    <div id="navbar" className="navbar fr" onClick={this.props.logout ? this.props.logout : this.handleLogout}>
                        <a className="handBtn">
                            <span>Log Out</span>
                        </a>
                    </div>
                    {this.props.bugReport ?
                        <ReportBugForm {...this.props} />
                        :null
                    }
                    {this.props.notifications ?
                        <DropDownNotifications {...this.props} />
                        :null
                    }

                    {this.props.dataCharts || this.props.admin || this.props.contentManagement||this.props.schoolManagement?null:
                        <div>
                            <div id="navbar" className="navbar fr" onClick={this.handleGetStarted} style={{marginLeft:-30}}>
                                <a className="handBtn  active">
                                    <span>Getting Started</span>
                                </a>
                            </div>

                            <ReactModal isOpen={this.state.getStarted} style={customStyle}>
                                <div className="modal-content content">
                                    <div className="modal-header">
                                        <div className="clearfix"></div>
                                        <h2>Getting Started</h2>
                                        <ResourcesLinkComponent value={104} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1tq1YlUUnuJJ7rkRWac7W1-nL-GyxujEnchIGj5YfQAE/"} title={"How to Log in, Create a Class and Add a Student"}/>
                                        <ResourcesLinkComponent value={102} teacherId={this.props.teacherId} url={"https://youtu.be/MJV2hAipd5c"} title={"VIDEO: How to Log in, Create a Class and Add a Student"}/>
                                        <ResourcesLinkComponent value={103} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1A88PHzgLpOFqDNfT2WSxRDCCrMf-objT1J0sgS67b94/edit?usp=sharing"} title={"Selecting apps for a student"}/>
                                        <ResourcesLinkComponent value={105} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1nZqoGGYdv3Ba7CkvdbYSoYAboWa3bvwN-_NzLPysdQM/edit?usp=sharing"} title={"Add a Parent Account"}/>
                                        <ResourcesLinkComponent value={108} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1bq4Oxxgtvdu0IrFwV-5Y41Ayt6z1mLIR5lGxGneV1PI/edit?usp=sharing"} title={"Share a Student"}/>
                                        <ResourcesLinkComponent value={109} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit"} title={"Technical documentation for each of the apps"}/>

                                        <br/>
                                        <h3>When You’re Ready</h3>
                                        <ResourcesLinkComponent value={106} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1Sx4IklA7n5YlxPyGHTPwb1GKIp4nR5lWBdvfCZEYzq8/edit?usp=sharing"} title={"Scoring"}/>
                                        <ResourcesLinkComponent value={107} teacherId={this.props.teacherId} url={"https://docs.google.com/document/d/1SU81DQjcqJkfexNCO3oVU_UpBRt13LD0EKSk3Wul-qo/edit?usp=sharing"} title={"Accessing the Data Charts: Overview"}/>
                                        <ResourcesLinkComponent value={40} teacherId={this.props.teacherId}  url={"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit"} title={"App Info"}/>
                                    </div>
                                    <div className="modal-footer">
                                        <a onClick={this.closeGetStarted} className="handBtn"><span>Close</span></a>
                                    </div>
                                </div>
                            </ReactModal>
                        </div>
                    }
                </div>
            </nav>
        )
    }
};

const bindActionToProps = dispatch => {
    return {
        selectSchool: async(selectedSchool) => await dispatch(selectSchool(selectedSchool)),
        userLogout: async() => await dispatch(userLogout())
    };
};

const mapStateToProps = state => ({
    lastSchool: state.teacherReducer.lastSchool
});

export default withRouter(connect(mapStateToProps,bindActionToProps)(Header));



// WEBPACK FOOTER //
// ./src/Shared/Header.js